export const filtersTypes = { all: "all", private: "private", starred: "starred", shared: "shared" };

export const savedListColumns = {
  star: {
    key: "star",
    dataIndex: "star",
    title: "Star",
    display: true,
    mandatory: true
  },
  name: {
    key: "name",
    dataIndex: "name",
    title: "List Type and Name",
    display: true,
    mandatory: true
  },
  updatedAt: {
    key: "updatedAt",
    dataIndex: "updatedAt",
    title: "Last Modified",
    display: true,
    mandatory: true
  },
  numberOfRecords: {
    key: "numberOfRecords",
    dataIndex: "numberOfRecords",
    title: "# Of Records",
    display: true,
    mandatory: true
  },
  actions: {
    key: "actions",
    dataIndex: "actions",
    title: "",
    display: true,
    mandatory: true
  }
};

export const filtersTypesOptions = [
  {
    index: 1,
    key: filtersTypes.all,
    id: "saved_lists_all_lists_view",
    value: (t) => t("savedList.types_options.all")
  },
  {
    index: 2,
    key: filtersTypes.starred,
    id: "saved_lists_favorite_lists_view",
    value: (t) => t("savedList.types_options.favorite")
  },
  {
    index: 3,
    key: filtersTypes.private,
    id: "saved_lists_private_lists_view",
    value: (t) => t("savedList.types_options.private")
  },
  {
    index: 4,
    key: filtersTypes.shared,
    id: "saved_lists_homepage_shared_view",
    value: (t) => t("savedList.types_options.shared")
  }
];

export const PUBLIC = "public";
export const PRIVATE = "private";
export const SHARED = "shared";
